import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2, Monitor, Smartphone, Trash2 } from "lucide-react";
import { toast } from "sonner";

const fmt = (d) => (d ? new Date(d).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");
const isMobile = (l = "") => /Android|iPhone|iPad/.test(l);

export function DevicesPanel({ userId }) {
  const { logout } = useAuth();
  const [data, setData] = useState(null);
  const base = userId ? `/users/${userId}/devices` : "/auth/devices";
  const mine = !userId;
  const current = mine ? localStorage.getItem("omnibat_device_id") : null;

  const load = () => api.get(base).then((r) => setData(r.data.devices)).catch((e) => { toast.error(apiErr(e)); setData([]); });
  useEffect(() => { load(); }, [base]); // eslint-disable-line react-hooks/exhaustive-deps

  const remove = async (d) => {
    const self = d.device_id === current;
    const msg = self ? "Retirer cet appareil ? Vous serez déconnecté et un code vous sera demandé à la prochaine connexion."
      : `Retirer « ${d.label} » ? Les sessions ouvertes sur cet appareil seront fermées et un code sera demandé à la prochaine connexion.`;
    if (!window.confirm(msg)) return;
    try { await api.delete(`${base}/${d.device_id}`); toast.success("Appareil retiré"); if (self) logout(); else load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (!data) return <p className="text-sm text-slate-500 py-4"><Loader2 className="inline h-4 w-4 animate-spin mr-1" />Chargement…</p>;
  if (!data.length) return <p className="text-sm text-slate-500 py-4" data-testid="devices-empty">Aucun appareil enregistré.</p>;
  return (
    <ul className="divide-y rounded-lg border max-h-80 overflow-y-auto" data-testid="devices-list">
      {data.map((d) => {
        const Icon = isMobile(d.label) ? Smartphone : Monitor;
        const isCur = d.device_id === current;
        return (
          <li key={d.device_id} className="flex items-center gap-3 p-3" data-testid={`device-row-${d.device_id}`}>
            <Icon className="h-5 w-5 text-slate-500 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{d.label || "Appareil"} {isCur && <span className="ml-1 rounded-full bg-emerald-100 text-emerald-700 text-[10px] px-2 py-0.5" data-testid="device-current-badge">Cet appareil</span>}</p>
              <p className="text-[11px] text-slate-500">IP {d.ip || "—"} · Ajouté le {fmt(d.first_seen)} · Dernière connexion {fmt(d.last_seen)}</p>
            </div>
            <Button size="sm" variant="ghost" onClick={() => remove(d)} className="text-rose-600 hover:text-rose-700 hover:bg-rose-50" data-testid={`device-remove-${d.device_id}`}>
              <Trash2 className="h-4 w-4 sm:mr-1" /><span className="hidden sm:inline">Retirer</span>
            </Button>
          </li>
        );
      })}
    </ul>
  );
}
